<template>
  <v-list-item>
    <span v-if="disabled" :style="appStyle_DashboardLinkDisabled">
      {{ linkText }}
    </span>
    <v-list-item-content v-else>
      <span @click="$emit('click')" style="cursor: pointer;">
        <slot name="link-text">
          <span :style="appStyle_DashboardLink">{{ linkText }}</span>
        </slot>
      </span>
    </v-list-item-content>

    <v-list-item-action v-if="!disabled">
      <v-tooltip v-model="tooltip" top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small icon @click="tooltip = !tooltip">
            <v-icon>info</v-icon>
          </v-btn>
        </template>
          {{ infoText }}
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { AppStyle } from '@/config.js'
import { EventBus } from '@/event-bus.js'

export default {
  name: 'DashboardLink',
  data() {
    return {
      appStyle_DashboardLink: AppStyle.DashboardLink,
      appStyle_DashboardLinkDisabled: AppStyle.DashboardLinkDisabled,
      tooltip: false
    }
  },
  props: {
    linkText: {
      type: String,
      default: null
    },
    infoText: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  beforeMount() {
    EventBus.$on('mouse-click', () => {
      if (this.tooltip === true) {
        this.tooltip = false
      }
    })
  }
}
</script>